import * as React from 'react';

// tslint:disable:max-line-length
export const MoviesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M11 6c0-.6-.4-1-1-1H8V2c0-.6-.4-1-1-1H2v2h4v2H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h9c.6 0 1-.4 1-1v-2l5 2V6l-5 2V6z"
    />
  </svg>
);
